var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBycle2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4602 47.5602C44.6662 47.5602 54.6127 37.6358 54.6127 25.4076C54.6127 13.2016 44.6662 3.25513 32.4602 3.25513C20.232 3.25513 10.3077 13.2016 10.3077 25.4076C10.3077 37.4286 19.8984 47.2231 31.8404 47.5517L32.4602 47.5602Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3736 18.0318L35.6406 18.4214L31.8975 15.046C31.2629 14.4776 30.3407 14.3603 29.5899 14.7594L27.2659 15.9947L28.2162 17.7824L30.5402 16.547L33.7457 19.4287L29.4464 21.714L28.6495 20.9913L29.6416 20.4639L28.6913 18.6762L24.2222 21.0519L25.1725 22.8395L26.7367 22.008L30.7391 25.6125L30.1402 25.9308C28.6874 24.1466 26.232 23.5603 24.0881 24.5738C21.5189 25.779 20.4361 29.0257 21.7664 31.5284C23.0968 34.0312 26.1085 34.9523 28.6112 33.6219C30.8101 32.4531 31.7858 29.997 31.0905 27.7185L34.8446 25.7229C36.2974 27.5071 38.7528 28.0934 40.8967 27.0799C43.4612 25.8657 44.5487 22.628 43.2136 20.1163C41.888 17.6225 38.8763 16.7014 36.3736 18.0318ZM29.2313 28.7067C29.4297 29.9426 28.8498 31.2023 27.661 31.8343C26.1593 32.6325 24.3523 32.0798 23.5541 30.5782C22.7559 29.0765 23.3086 27.2695 24.8102 26.4713C25.999 25.8393 27.3676 26.0633 28.2811 26.9191L25.7605 28.2589L26.7107 30.0466L29.2313 28.7067ZM33.8943 23.9352L32.6429 24.6004L31.0402 23.1596L33.7485 21.72C33.6308 22.4474 33.6631 23.1983 33.8943 23.9352ZM40.1746 25.1824C38.673 25.9806 36.8659 25.428 36.0677 23.9263C35.6258 23.0951 35.6122 22.1852 35.9229 21.3895L38.0354 23.2931L39.3927 21.792L37.2571 19.8664C37.2749 19.8569 37.297 19.8337 37.3238 19.8194C38.8255 19.0212 40.6325 19.5739 41.4307 21.0755C42.2289 22.5772 41.6762 24.3842 40.1746 25.1824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3995 33.4526L31.8242 35.3531L38.6126 35.1838L37.6623 33.3961L41.2377 31.4956L34.4493 31.6649L35.3995 33.4526Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -2.71258,
    y: -9.76513,
    width: 70.3456,
    height: 70.3456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.51013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -1.49994,
    y1: -9.99994,
    x2: 44.0001,
    y2: 63.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44EB45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BE92C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBycle2);
export default __webpack_public_path__ + "static/media/bycle2.00a6abe6c3a4dbac89443c5e52a97903.svg";
export { ForwardRef as ReactComponent };